export default __webpack_public_path__ + "static/media/originals-cover.2016ed4a.png";